/**
 * MIRA Breadcrumb Component
 * Wraps Shadcn Breadcrumb with MIRA design system styles
 */

import React from 'react';
import {
  Breadcrumb as ShadcnBreadcrumb,
  BreadcrumbList as ShadcnBreadcrumbList,
  BreadcrumbItem as ShadcnBreadcrumbItem,
  BreadcrumbLink as ShadcnBreadcrumbLink,
  BreadcrumbPage as ShadcnBreadcrumbPage,
  BreadcrumbSeparator as ShadcnBreadcrumbSeparator,
  BreadcrumbEllipsis as ShadcnBreadcrumbEllipsis,
} from '@/components/ui/breadcrumb';
import { cn } from '@/lib/utils';
import styles from '@/styles/components/breadcrumb.module.css';

export const Breadcrumb = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <ShadcnBreadcrumb
      ref={ref}
      className={cn(styles.miraBreadcrumb, className)}
      {...props}
    />
  );
});

Breadcrumb.displayName = 'MiraBreadcrumb';

export const BreadcrumbList = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <ShadcnBreadcrumbList
      ref={ref}
      className={cn(styles.miraBreadcrumbList, className)}
      {...props}
    />
  );
});

BreadcrumbList.displayName = 'MiraBreadcrumbList';

export const BreadcrumbItem = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <ShadcnBreadcrumbItem
      ref={ref}
      className={cn(styles.miraBreadcrumbItem, className)}
      {...props}
    />
  );
});

BreadcrumbItem.displayName = 'MiraBreadcrumbItem';

export const BreadcrumbLink = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <ShadcnBreadcrumbLink
      ref={ref}
      className={cn(styles.miraBreadcrumbLink, className)}
      {...props}
    />
  );
});

BreadcrumbLink.displayName = 'MiraBreadcrumbLink';

export const BreadcrumbPage = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <ShadcnBreadcrumbPage
      ref={ref}
      className={cn(styles.miraBreadcrumbPage, className)}
      {...props}
    />
  );
});

BreadcrumbPage.displayName = 'MiraBreadcrumbPage';

export const BreadcrumbSeparator = ({ className, ...props }) => {
  return (
    <ShadcnBreadcrumbSeparator
      className={cn(styles.miraBreadcrumbSeparator, className)}
      {...props}
    />
  );
};

export const BreadcrumbEllipsis = ({ className, ...props }) => {
  return (
    <ShadcnBreadcrumbEllipsis
      className={cn(styles.miraBreadcrumbEllipsis, className)}
      {...props}
    />
  );
};
